
import {
  Button,
  Form,
  Grid,
  Header,
  Image,
  Message,
  Segment,
} from "semantic-ui-react";

import logo from "../../assets/images/dim_logo_color.svg";

const LoginUI = ({
  form: { onChange, form, LoginFormValid, error, onSubmit, loading },
}) => {
  return (
    <Grid centered style={{ height: "100vh"}} verticalAlign="middle">
      <Grid.Column style={{ maxWidth: 450 }}>
        <Image centered src={logo} width={180} />
        <Header as="h2" color="blue" textAlign="center" style={{ margin: 10 }}>
          Portal Médico
        </Header>
        <Segment stacked>
          <Form>
            {error && <Message content={error?.detail} negative />}
            <Form.Field>
              <Form.Input
                value={form.username || ""}
                onChange={onChange}
                fluid
                icon="doctor"
                iconPosition="left"
                name="username"
                placeholder="Usuario"
                label="Usuario"
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                value={form.password || ""}
                onChange={onChange}
                icon="lock"
                iconPosition="left"
                name="password"
                type="password"
                placeholder="Contraseña"
                label="Contraseña"
              />
            </Form.Field>
            <Button
              onClick={onSubmit}
              disabled={!LoginFormValid || loading}
              fluid
              loading={loading}
              primary
              type="submit"
            >
              Ingresar
            </Button>
          </Form>
        </Segment>
      </Grid.Column>
    </Grid>
  );
};

export default LoginUI;
